<template>
  <div @click="toggleShowShopDetail" class="detail-container">
    <div @click.stop class="detail-view">
      <div class="bg"/>
      <div class="meal-info">
        <span class="title">{{ $store.state.meals.single_meal_info.menu_name }}</span>
        <span class="title remark">{{ $store.state.meals.single_meal_info.menu_notice }}</span>
        <img class="img" :src="$store.state.meals.single_meal_info.photo" @error="errorLoadImg()">
      </div>
      <div @click="addToShoppingCart" class="btn">{{ btnTitle }}</div>
      <div class="comment">
        <div class="comment-view">
          <div class="comment-text">
            <div class="title">评论</div>
            <div class="arrow"/>
          </div>
          <div v-if="commentsArr.length" class="comment-item">
            <Comment
              v-for="(item, index) in commentsArr"
              :key="index"
              :comment="item"
            />
          </div>
          <div v-else class="no-comment">暂无评论信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '@/components/meals/comment'

export default {
  name: 'MealDetail',
  components: {
    Comment
  },
  data () {
    return {
      commentsArr: [],
      isAddToShoppingCart: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      let params = {
        busi_id: this.$store.state.meals.busi_id,
        menu_id: this.$store.state.meals.single_meal_info.menu_id,
        menu_spec_id: this.$store.state.meals.single_meal_info.menu_spec_id,
      }
      // 请求商品评论数据
      this.APIS.REQUEST_MEAL_COMMENTS(params)
      .then((res) => {
        if (res.data.status === 0) {
          this.commentsArr = res.data.discuss_data
        }
      })
      .catch((err) => {
        console.log(err)
      })
    })
  },
  computed: {
    // 按钮文字
    btnTitle () {
      let isInshoppingCart = false
      this.$store.state.shopping_cart_data.map((items, index) => {
        items.map((item, i) => {
          if (this.$store.state.meals.single_meal_info.menu_id === item.menu_id) {
            isInshoppingCart = true
          }
        })
      })
      return isInshoppingCart ? '查看购物车' : '加入购物车'
    }
  },
  methods: {
    /**
     * 隐藏商品详情页面
     */
    toggleShowShopDetail () {
      this.$store.commit('toggle_show_shop_detail')
    },
    /**
     * 将商品添加进购物车, 如果购物车里已有该商品，提示已有该商品，否则添加进购物车
     */
    addToShoppingCart () {
      !this.isAddToShoppingCart && this.$store.state.shopping_cart_data.map((items, index) => {
        items.map((item, i) => {
          if (this.$store.state.meals.single_meal_info.menu_id === item.menu_id) {
            this.isAddToShoppingCart = true
          }
        })
      })
      if (this.isAddToShoppingCart) {
        this.$store.commit('toggle_show_shopping_cart', true)
        this.toggleShowShopDetail()
      } else {
        this.$store.commit('set_shopping_cart_data', this.$store.state.meals.single_meal_info)
        this.$store.commit('show_alert', '商品在购物车等您呦')
      }
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg () {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/meals/pic_home_default.png"
    }
  },
}
</script>

<style lang="less" scoped>
.detail-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  background: rgba( 0, 0, 0, .5);
  z-index: 1001;
  overflow: auto;
  cursor: pointer;
  .detail-view {
    width: 520px;
    height: 860px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    border-radius: 10px;
    cursor: default;
    .bg {
      width: 520px;
      height: 200px;
      background: url("../../../static/img/meals/bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .meal-info {
      width: 440px;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      margin-top: -160px;
      .title {
        width: 90%;
        height: 24px;
        text-align: center;
        font-size: 24px;
        color: #333333;
        margin-top: 10px;
        z-index: 10;
      }
      .remark {
        font-size: 12px;
        color: #a5a5a5;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .img {
        width: 280px;
        height: 280px;
        border-radius: 140px;
        margin-top: 8px;
      }
    }
    .btn {
        width: 160px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
        margin-top: -30px;
        background-color: #ff4c4c;
        box-shadow: 0px 10px 10px 0px rgba(224, 34, 34, 0.2);
        border-radius: 30px;
      }
    .comment {
      width: calc(~"100% - 16px");
	    height: 310px;
      display: flex;
      justify-content: center;
      margin-top: 55px;
      overflow-y: auto;
      .comment-view {
         width: 468px;
         .comment-text {
          margin-bottom: 20px;
          .title {
            font-size: 24px;
            color: #333333;
          }
          .arrow {
            width: 48px;
            height: 4px;
            margin-top: -6px;
            background-color: #ff9a28;
          }
        }
        .comment-item {
          width: 468px;
          height: 290px;
        }
        .no-comment {
          color: #999999;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/meals/meal_detail.vue